// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ms-0";
export var discountCodeInput = "_ms-1";